// extracted by mini-css-extract-plugin
module.exports = {"label":"LanguageSelectionDropdown_label__UJskX h6 d-block text-center","selectOptions":"LanguageSelectionDropdown_selectOptions__1mg6R select-options"};